// SCREEN_CONTACT (お問い合わせ) で使うAPI

export const sendContact = async (message) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/contact`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "問い合わせの送信に失敗しました");
  }
};
